module.exports = __webpack_public_path__ + "static/img/8.3fa11d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/8.png
// module id = M4Qg
// module chunks = 0